const PreviewServices = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl font-bold text-gray-900 mb-6">Services (Preview)</h1>
        <p className="text-xl text-gray-600">This page uses the existing Services design. Navigate using the menu above.</p>
      </div>
    </div>
  );
};

export default PreviewServices;